/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const ContentSection = styled(({ children, fullWidth, ...props }) => (
  <Grid
    {...props}
    item
    xs={12}
    md={fullWidth ? 12 : 9}
    xl={fullWidth ? 12 : 10}>
    <div className="content-section min-height">{children}</div>
  </Grid>
))`
  ${({ theme }) => `
    .content-section {
      padding: ${theme.spacing(3)}px ${theme.spacing(2)}px;
      overflow: auto;
    
      ${theme.breakpoints.up("md")} {
        padding: ${theme.spacing(6)}px ${theme.spacing(5)}px;
      }
    }
  `}
`;

export default ContentSection;
